import { Link, useNavigate } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { informationsRouteList } from "../App";
import { lang } from "../assets/languages/en.language";
import Header from "../components/Header.component";
import HandHearth from "../components/svgs/illustrations/HandHearth";
import { RoundCta } from "../styles/Button.style";
import { MainContainer, RootContainer } from "../styles/Container.style";
import { Paragraph } from "../styles/Text";
import { Column, Gap } from "../styles/Utils";

export default function InformationsPage() {
  const theme = useTheme();
  const navigate = useNavigate();

  const informationPages = [
    {
      title: lang.informationsPage.PageLinkNames.theCynoMethod,
      route: informationsRouteList.theCynoMethod,
    },
    {
      title: lang.informationsPage.PageLinkNames.dogBodyLanguage,
      route: informationsRouteList.dogBodyLanguage,
    },
    {
      title: lang.informationsPage.PageLinkNames.tipsAndAdvice,
      route: informationsRouteList.tipsAndAdvice,
    },
    {
      title: lang.informationsPage.PageLinkNames.faq,
      route: informationsRouteList.faq,
    },
  ];

  const openInfoPage = (route: string) => {
    console.log("openInfoPage");
    navigate(route);
  };

  return (
    <RootContainer>
      {/* <Column $alignItem="center" $flexGrow={1}> */}
      <Column $alignItem="center">
        <Header sloganImgSrc="/slogans/slogan-red.png" />
        <MainContainer $flexGrow={1}>
          <Paragraph>{lang.informationsPage.message}</Paragraph>
          <Gap $height={1} />
          <Column $gap={0.5} $flexGrow={1}>
            {informationPages.map((e) => (
              <RoundCta
                key={e.title}
                onClick={() => openInfoPage(e.route)}
                $background={theme.color.primaryDark}
                $color={theme.color.tertiaryLight}
              >
                {e.title}
              </RoundCta>
            ))}
          </Column>
          <Gap $height={1} />
          <IllustrationWrapper>
            <HandHearth />
          </IllustrationWrapper>
        </MainContainer>
      </Column>
    </RootContainer>
  );
}

const IllustrationWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 8rem;
  svg {
    width: 100%;
    position: absolute;
    bottom: 0px;
    height: 100%;
    transform: translateX(0px) translateY(2rem);
  }
`;

export const Image = styled.img<{ $width: string }>`
  max-width: unset !important;
  /* transform: translateX(-1rem); */
  width: ${(props) => props.$width};
`;

export const LinkOvl = styled(Link)<{ $top: number; $left?: number; $width?: number; $height?: number }>`
  /* background-color: yellow;
  opacity: 0.3; */
  position: absolute;
  width: ${(props) => `${props.$width ?? 81}%`};
  top: ${(props) => props.$top + "%"};
  left: ${(props) => `${props.$left ?? 50}%`};
  /* transform: translateX(-50%); */
  height: ${(props) => `${props.$height ?? 10}%`};
`;
